import { BaseIcon, BaseIconProps } from './BaseIcon';

export const Gamepad2Gradient: React.FC<BaseIconProps> = (props) => (
  <BaseIcon gradientId="gamepad2Grad" {...props}>
    <path d="M6 11h4M8 9v4m7-2h.01M18 10h.01" stroke="url(#gamepad2Grad)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M6 7a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v10a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2z" stroke="url(#gamepad2Grad)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
  </BaseIcon>
);
